<template>
	<picture>
		<source :media="media" :data-srcset="desktopSrcset" />
		<source :data-srcset="mobileSrcset" />
		<img
			:src="placeholder"
			class="vpic lazyload"
			:class="custom_class"
			:alt="media.alt || $attrs.alt || 'Banner'"/>
	</picture>
</template>

<script>
export default {
	name: 'VPic',

	props: {
		media: {
			type: String,
			required: true,
			default: '--mobile-up',
		},
		mobile_media: {
			type: Object,
			required: true,
		},
		desktop_media: {
			type: Object,
			required: true,
		},
		custom_class: {
			type: String,
			required: false,
		},
	},

	computed: {
		mobileSrcset() {
			let srcset = `${this.$image(this.mobile_media.src, '200x')} 100w`;

			this.mobile_media.width >= 200
				? (srcset += `, ${this.$image(this.mobile_media.src, '400x')} 200w`)
				: '';
			this.mobile_media.width >= 400
				? (srcset += `, ${this.$image(this.mobile_media.src, '800x')} 400w`)
				: '';
			this.mobile_media.width >= 600
				? (srcset += `, ${this.$image(this.mobile_media.src, '1200x')} 600w`)
				: '';

			return srcset;
		},
		desktopSrcset() {
			let srcset = `${this.$image(this.desktop_media.src, '800x')} 400w`;

			this.desktop_media.width >= 600
				? (srcset += `, ${this.$image(this.desktop_media.src, '1200x')} 600w`)
				: '';
			this.desktop_media.width >= 800
				? (srcset += `, ${this.$image(this.desktop_media.src, '1600x')} 800w`)
				: '';
			this.desktop_media.width >= 1000
				? (srcset += `, ${this.$image(this.desktop_media.src, '2000x')} 1000w`)
				: '';
			this.desktop_media.width >= 1500
				? (srcset += `, ${this.$image(this.desktop_media.src, '3000x')} 1500w`)
				: '';
			this.desktop_media.width >= 2000
				? (srcset += `, ${this.$image(this.desktop_media.src, '2000x')} 2000w`)
				: '';

			return srcset;
		},
		placeholder() {
			const responsive = this.media
				.split('--')
				.pop()
				.replaceAll('-', '_');

			const w = this.$screen[responsive]
				? this.desktop_media.width
				: this.mobile_media.width;
			const h = this.$screen[responsive]
				? this.desktop_media.height
				: this.mobile_media.height;

			if (!w || !h) return '';
			return `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}"%3E%3C/svg%3E`;
		},
	},
};
</script>

<style scoped>
.vpic {
	background-color: var(--color-rice);
	background-image: var(--placeholder);
	background-repeat: no-repeat;
	background-size: 45%;
	background-position: center;
}

.lazyloaded:not(.remove-transition) {
	transition: background-color 0.275s;
	background-color: transparent;
	background-image: none;
}

img.lazyload:not([src]) {
	visibility: hidden;
}
</style>
